import enums from "config/enums";
import { isUndefined } from "lodash";

/* This code defines an object called `localStorageUtils` that contains four methods for interacting
with the browser's `localStorage` API: `@get`, `@set`, `@remove`, and `@update`. */
export const localStorageKeys = {
  token: "token",
  mainClient: enums.asyncStorage.mainClientDetails,
  userDetails: enums.asyncStorage.userDetails,
  selectedProduct: "selectedProduct",
  cartItems: enums.asyncStorage.cartItems,
  division: "division",
  divisions: "divisions",
  category: enums.asyncStorage.categories,
  isLastScroll: "__is_last_scroll",
  wishListItems: enums.asyncStorage.wishes,
  isWishlistAdded: "__isWishlistAdded",
  isNumberVerified: "sheen:__numberVerified",
  basicStepFormVisited: "sheen:__basicStepFormVisited",
};

const localStorageUtils = {
  get: (key) => {
    try {
      const item = localStorage?.getItem(key) || null;
      return isUndefined(item) || item === "undefined"
        ? null
        : JSON.parse(item);
    } catch (error) {
      console.error(`Error getting item from localStorage: ${error}`);
      return null;
    }
  },
  set: (key, value) => {
    try {
      const item = JSON.stringify(value);
      localStorage.setItem(key, item);
    } catch (error) {
      console.error(`Error setting item in localStorage: ${error}`);
    }
  },
  remove: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item from localStorage: ${error}`);
    }
  },
  update: (key, callback) => {
    try {
      const item = localStorageUtils.get(key);
      const updatedItem = callback(item);
      localStorageUtils.set(key, updatedItem);
    } catch (error) {
      console.error(`Error updating item in localStorage: ${error}`);
    }
  },
};

export default localStorageUtils;
